import { Collapse } from "react-collapse";

import FormattedMessage from "@components/UI/FormattedMessage";

import FlightDetailSegment from "../Flights/FlightDetailSegment";
import FlightDetailStreamTransfer from "../Flights/FlightDetailStreamTransfer";
import FormatDuration from "../Formatters/FormatDuration";

interface Props {
  flightStream: any;
  show?: boolean;
}

export default function FlightDetail(props: Props) {
  const { flightStream, show } = props;

  const flightSegments = flightStream.FlightSegments;
  return (
    <div className="best-offer-detail">
      <Collapse isOpened={show}>
        <div style={{ overflow: "hidden" }}>
          <div style={{ marginTop: "50px" }}>
            <div className="flight-detail-duration">
              <FormattedMessage id="FlightDetail.wholeTime" />:{" "}
              <FormatDuration
                flight-detail-duration
                duration={flightStream.JourneyDuration}
              />
            </div>
            {flightSegments.map((oFlightSegment, index) => (
              <div key={`${oFlightSegment.FlightNumber}-${index}`}>
                <FlightDetailSegment
                  underTransfer={index !== 0}
                  oFlightSegment={oFlightSegment}
                />
                {index < flightSegments.length - 1 && (
                  <FlightDetailStreamTransfer
                    arrivalDateTime={oFlightSegment.ArrivalDateTime}
                    departureDateTimeNextSegment={
                      flightSegments[index + 1].DepartureDateTime
                    }
                  />
                )}
              </div>
            ))}
            <div />
          </div>
        </div>
      </Collapse>
    </div>
  );
}
